export default __webpack_public_path__ + "static/pulse-93c757fa711b028d7c1559ac55f526e7.jpg";